// src/backendServices/broadcastingManagment/api_category.ts


import   axios                                     from 'axios';

import { API_URLS                               }  from '../urls';

import { BackendResponse                        ,
         handleError                            ,
         DUPLICATE_NAME_CODE                    ,
         isDuplicateNameRefusal                 ,
         extractApiErrorDetail                  }  from '../../dataTypes/backendServicesManagment/types'

import { BroadcastingChannelCategory            ,
         initializedBroadcastingChannelCategory }  from '../../dataTypes/broadcastingManagment/types'

export interface BackendResponse_BroadcastingChannelCategory extends BackendResponse<BroadcastingChannelCategory []> {}

             
export const getBroadcastingChannelCategories = async (adminId?: number): Promise<BackendResponse_BroadcastingChannelCategory> => {

  const url         = API_URLS.getBroadcastingChannelCategories;
  const queryParams = new URLSearchParams();
  if (adminId) queryParams.append('adminId', adminId.toString());
  const queryString = queryParams.toString();
  const fullUrl      = queryString ? `${url}?${queryString}` : url;

  try
   {
    const response = await axios.get(fullUrl);

    if (response.status === 200)
	      {
           const categories: BroadcastingChannelCategory[] = response.data['hydra:member'].filter((category: any) => category.visible !== false).map((category: any) => {

             const defaultCategory = initializedBroadcastingChannelCategory();

             return {
                ...defaultCategory,
                id          : category.id          ?? defaultCategory.id          ,
                name        : category.name        ?? defaultCategory.name        ,
                rank        : category.rank        ?? defaultCategory.rank        ,
                visible     : category.visible     ?? defaultCategory.visible     ,
             };
           });

           return {
             code    : 1,
             comment : "The retrieval of video categories is complete.",
             payload : categories
           };
          }
	 else {
           return handleError<BroadcastingChannelCategory []>(response.status, "Non-200 response from API");
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
	 {
      return handleError<BroadcastingChannelCategory []>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<BroadcastingChannelCategory []>(-102, "Unknown error");
   }
};

export const createBroadcastingChannelCategory = async ( name        : string  ,
                                                         rank        : number  ,
                                                         visible     : boolean ,
                                                         adminId?    : number  ): Promise<BackendResponse<BroadcastingChannelCategory>> => {
  const url = API_URLS.createBroadcastingChannelCategory;

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json'
  };

  const rankStr:    string = `${rank}`;
  const visibleStr: string = visible ? 'true' : 'false';

  try {
    const response = await axios.post(url, { name, rankStr, visibleStr, ...(adminId ? { adminId } : {}) }, { headers });

    if (response.status === 201) {
      const defaultCategory = initializedBroadcastingChannelCategory();
      const created: BroadcastingChannelCategory = {
        ...defaultCategory,
        id      : response.data?.id      ?? defaultCategory.id      ,
        name    : response.data?.name    ?? defaultCategory.name    ,
        rank    : response.data?.rank    ?? defaultCategory.rank    ,
        visible : response.data?.visible ?? defaultCategory.visible ,
      };
      return {
        code: 1,
        comment: "A new broadcasting channel category has been successfully created.",
        payload : created
      };
    } else {
      return handleError<BroadcastingChannelCategory>(response.status, "Non-201 response from API");
    }
  } catch (error) {

    if (axios.isAxiosError(error)) {
      const detail = extractApiErrorDetail(error.response?.data, error.message);

      // Un nom déjà pris n'est pas une panne : l'écran a de quoi le dire à
      // l'utilisateur, à condition de pouvoir le distinguer du reste.
      if (isDuplicateNameRefusal(error.response?.status, detail)) {
        return handleError<BroadcastingChannelCategory>(DUPLICATE_NAME_CODE, detail);
      }

      return handleError<BroadcastingChannelCategory>(-101, detail);
    }
    return handleError<BroadcastingChannelCategory>(-102, "Unknown error");
  }
};

export const patchBroadcastingChannelCategory = async ( id          : number  ,
                                                        name        : string  ,
                                                        rank        : number  ,
                                                        visible     : boolean ,
                                                        adminId?    : number  ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.patchBroadcastingChannelCategory}`;
  const url = baseUrl.replace("{id}", `${id}`);

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json'
  };

  try
   {
    const response = await axios.patch(url, { name, rank, visible, ...(adminId ? { adminId } : {}) }, { headers });

    if (response.status === 200)
          {
           return {
                    code    : 1,
                    comment : `The update of product category ${id} is complete.`,
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, "Non-200 response from API");
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      const detail = extractApiErrorDetail(error.response?.data, error.message);

      // Même refus qu'à la création, autre porte : renommer vers un nom déjà pris.
      if (isDuplicateNameRefusal(error.response?.status, detail))
       {
        return handleError<void>(DUPLICATE_NAME_CODE, detail);
       }

      return handleError<void>(-101, detail);
     }

    return handleError<void>(-102, "Unknown error");
   }
};

export const deleteBroadcastingChannelCategory = async (id: number, adminId?: number): Promise<BackendResponse> => {

  const baseUrl      = `${API_URLS.deleteBroadcastingChannelCategory}`;
  const queryParams  = new URLSearchParams();
  if (adminId) queryParams.append('adminId', adminId.toString());
  const queryString  = queryParams.toString();
  const url          = baseUrl.replace("{id}", `${id}`) + (queryString ? `?${queryString}` : '');

  const headers = {
    'Accept': 'application/ld+json'
  };

  try
   {
    const response = await axios.delete(url, { headers });

    if (response.status === 204)
          {
           return {
                    code    : 1,
                    comment : `The deletion of product category ${id} is complete.`,
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, "Non-204 response from API");
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, "Unknown error");
   }
};

